export default class PreviewConstraints {
    constructor() {        
        this.maintainAspectRatio = 1;
        this.resolution = -1;                
    }
}